<template>
    <HelpPage></HelpPage>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const HelpPage = defineAsyncComponent(() =>
    import(
        "../../components/Hr/HelpPage/HelpPage.vue"
        )
);

export default {
    name: "Hr_Help", //The name you are in should not equal the name of the component you are importing.
    components: { HelpPage, AuthLayout },
};
</script>
